
      import PrezioOnboard from '/src/index.ts';
      import { parseHostedPageParams } from '/src/hostedPage.ts';

      // ---------------------------------------------------------------
      // Host bridge — relay lifecycle events to the embedding context.
      // Detects iOS WKWebView, Android WebView, iframe, or standalone.
      // Message shape matches parentBridge.ts: { type, event, ...data }
      // ---------------------------------------------------------------
      function sendToHost(event, data) {
        const message = { type: 'prezio:onboard', event, ...(data || {}) };

        // iOS WKWebView (registered via WKUserContentController)
        if (window.webkit?.messageHandlers?.prezio) {
          try { window.webkit.messageHandlers.prezio.postMessage(message); return; } catch { /* silent */ }
        }

        // Android WebView (registered via addJavascriptInterface)
        if (window.PrezioNative?.postMessage) {
          try { window.PrezioNative.postMessage(JSON.stringify(message)); return; } catch { /* silent */ }
        }

        // iframe (parent frame listens via addEventListener('message', ...))
        if (window !== window.parent) {
          try { window.parent.postMessage(message, '*'); return; } catch { /* silent */ }
        }

        // Standalone (dev / "Open in tab") — console only
        console.log('[prezio:onboard]', event, data || '');
      }

      // Credentials loaded from .env.local via Vite's import.meta.env.
      // URL params override them — see src/hostedPage.ts for the full param list.
      const config = parseHostedPageParams(location.search, {
        token: import.meta.env.VITE_PREZIO_TOKEN,
        sessionId: import.meta.env.VITE_PREZIO_SESSION_ID,
        apiBaseUrl: import.meta.env.VITE_PREZIO_API_BASE_URL,
      });

      const handle = await PrezioOnboard.init({
        el: '#prezio-onboard',
        ...config,
        onComplete: (result) => sendToHost('complete', result),
        onStepChange: (event) => console.log('[demo] step change', event),
        onCancel: () => {
          sendToHost('cancel');
          // Hide the widget container (host is responsible for removal)
          document.getElementById('prezio-onboard')?.style.setProperty('display', 'none');
        },
        onError: (error) => sendToHost('error', error),
      });

      // Expose handle for console debugging
      window.__prezio = handle;
    